export default __webpack_public_path__ + "static/logo-d76e3f3da45cf0a68111a01b5484f19c.svg";